import { css } from '@emotion/core';

/* stylelint-disable property-no-vendor-prefix */
export default {
  name: "16q9xmc",
  styles: "position:absolute;width:1px;height:1px;margin:-1px;padding:0;clip:rect(1px,1px,1px,1px);border:0;overflow:hidden;clip-path:inset(100%);-webkit-clip-path:none;"
};